import { render } from "./JoinPage.vue?vue&type=template&id=2e40b28e"
import script from "./JoinPage.vue?vue&type=script&lang=js"
export * from "./JoinPage.vue?vue&type=script&lang=js"
script.render = render

export default script